// =============================
// File: src/components/user/Options.jsx (UPDATED - only the relevant parts)
// =============================
import React, { useState } from 'react';
import { 
  User, 
  Clock, 
  Headphones, 
  LogOut, 
  ChevronRight,
  Store,
  Radio,
  MessageCircle,
  Package,
  X,
  Sparkles,
  Handshake,
  BookOpen,
  ExternalLink  // Add this import
} from 'lucide-react';
import DocsCarousel from './DocsCarousel';

function Options({ 
  userId, 
  username,
  setActiveComponent, 
  onLogout 
}) {
  const [showTiendaModal, setShowTiendaModal] = useState(false);

  function handleSupportClick() {
    window.open('https://wa.me/51977689676', '_blank', 'noopener,noreferrer');
  }

  function handleInstruccionesClick() {
    // Open docs in new window
    window.open('/#/user-docs', '_blank', 'noopener,noreferrer');
  }

  const menuItems = [
    {
      id: 'Analytics',
      label: 'Mis Entregas',
      icon: Clock,
      onClick: () => setActiveComponent('Analytics'),
      color: 'from-[#B1336E] to-[#E6B43C]',
    },
    {
      id: 'ControlTower',
      label: 'Torre de Control',
      icon: Radio,
      onClick: () => setActiveComponent('ControlTower'),
      color: 'from-[#67A43C] to-[#E6B43C]',
    },
    {
      id: 'Chat',
      label: 'Chat',
      icon: MessageCircle,
      onClick: () => setActiveComponent('Chat'),
      color: 'from-[#B1336E] to-[#67A43C]',
    },
    {
      id: 'Inventory',
      label: 'Inventario',
      icon: Package,
      onClick: () => setActiveComponent('Inventory'),
      color: 'from-[#E6B43C] to-[#B1336E]',
    },
    {
      id: 'Tienda',
      label: 'Tienda',
      icon: Store,
      onClick: () => setActiveComponent('ProviderCatalog'),
      color: 'from-[#67A43C] to-[#E6B43C]',
    },
    {
      id: 'Referidos',
      label: 'Referidos',
      icon: Handshake,
      onClick: () => setActiveComponent('Referrers'),
      color: 'from-[#67A43C] to-[#B1336E]',
    },
    {
      id: 'Instrucciones',
      label: 'Instrucciones',
      icon: BookOpen,
      onClick: handleInstruccionesClick,
      color: 'from-[#B1336E] to-[#E6B43C]',
      isExternal: true  // Add this flag
    },
    {
      id: 'Support',
      label: 'Soporte',
      icon: Headphones,
      onClick: handleSupportClick,
      color: 'from-[#B1336E] to-[#E6B43C]',
      isExternal: true  // Add this flag
    },
  ];

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-slate-50 via-white to-slate-50">
      {/* Fixed Header */}
      <div className="flex-shrink-0 bg-gradient-to-r from-brand-primary to-pink-600 shadow-md">
        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            {/* Logo/Brand Section */}
            <div className="flex items-center gap-3">
              <div className="bg-white p-2 rounded-lg shadow-sm">
                <Package className="w-6 h-6 text-brand-primary" />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-extrabold text-white font-montserrat tracking-tight">
                  FAST MAX
                </h1>
              </div>
            </div>

            {/* User Info Badge */}
            <div className="bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full hidden sm:block">
              <div className="flex items-center gap-2">
                <User className="w-4 h-4 text-white" />
                <span className="text-sm font-medium text-white font-montserrat">
                  {username || 'Usuario'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-4xl mx-auto px-4 py-6 sm:px-6 lg:px-8 sm:py-8">
          
          {/* DOCS CAROUSEL */}
          <DocsCarousel role="customer" />

          {/* Profile Card */}
          <button
            onClick={() => setActiveComponent('MyAccount')}
            className="w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-6 hover:shadow-md hover:border-[#B1336E]/30 transition-all duration-200 mb-6"
          >
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-[#B1336E] to-[#E6B43C] flex items-center justify-center shadow-lg flex-shrink-0">
                <User className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
              </div>
              <div className="flex-1 text-left min-w-0">
                <h2 className="text-lg sm:text-xl font-extrabold text-[#B1336E] font-montserrat truncate">
                  {username || 'Usuario'}
                </h2>
                <p className="text-sm text-slate-600 font-montserrat">Mi cuenta</p>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 flex-shrink-0" />
            </div>
          </button>

          {/* Menu Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={item.onClick}
                  className="group bg-white rounded-2xl shadow-sm border border-slate-200 p-6 hover:shadow-lg hover:scale-[1.02] transition-all duration-200"
                >
                  <div className="flex items-center gap-4">
                    <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow duration-200`}>
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="text-base sm:text-lg font-semibold text-slate-900 font-montserrat group-hover:text-[#B1336E] transition-colors duration-200">
                        {item.label}
                      </p>
                    </div>
                    {/* Show external link icon for external links */}
                    {item.isExternal ? (
                      <ExternalLink className="w-5 h-5 text-slate-400 group-hover:text-[#B1336E] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
                    ) : (
                      <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-[#B1336E] group-hover:translate-x-1 transition-all duration-200" />
                    )}
                  </div>
                </button>
              );
            })}
          </div>

        </div>
      </div>

      {/* Fixed Footer with Logout */}
      <div className="flex-shrink-0 bg-white border-t border-slate-200 shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <button
            onClick={onLogout}
            className="w-full bg-white hover:bg-red-50 border-2 border-red-200 hover:border-red-300 text-red-600 font-semibold py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-sm font-montserrat"
          >
            <LogOut className="w-5 h-5" />
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>

      {/* Tienda Coming Soon Modal */}
      {showTiendaModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl animate-in fade-in zoom-in duration-200">
            <div className="p-6">
              <button
                onClick={() => setShowTiendaModal(false)}
                className="absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-slate-400" />
              </button>

              <div className="flex flex-col items-center mb-6">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#B1336E] to-[#E6B43C] mb-4 shadow-lg">
                  <Store className="h-8 w-8 text-white" />
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <Sparkles className="w-5 h-5 text-[#E6B43C]" />
                  <h3 className="text-2xl font-extrabold text-[#B1336E] font-montserrat">
                    ¡Próximamente!
                  </h3>
                  <Sparkles className="w-5 h-5 text-[#E6B43C]" />
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <p className="text-base text-slate-700 font-montserrat leading-relaxed">
                  Estamos trabajando en una <span className="font-bold text-[#B1336E]">actualización revolucionaria</span> que transformará tu experiencia con Fast Max.
                </p>

                <div className="bg-gradient-to-r from-[#B1336E]/10 to-[#E6B43C]/10 rounded-xl p-4 border-l-4 border-[#B1336E]">
                  <h4 className="font-bold text-slate-900 font-montserrat mb-2">
                    🛍️ La Tienda Fast Max
                  </h4>
                  <p className="text-sm text-slate-700 font-montserrat leading-relaxed">
                    Pronto podrás <span className="font-semibold">comprar y vender productos contraentrega</span> directamente desde tu cuenta.
                  </p>
                </div>
              </div>

              <button
                onClick={() => setShowTiendaModal(false)}
                className="w-full rounded-xl px-4 py-3 text-sm font-semibold text-white shadow-md hover:shadow-lg transition-all bg-gradient-to-r from-[#B1336E] to-[#E6B43C] font-montserrat"
              >
                ¡Entendido! Me avisarán cuando esté lista
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Options;